import { SvgIconProps } from "@mui/material/SvgIcon";
import StyledSvgIconWrapper from "./wrappers/StyledSvgIconWrapper";

export const ReferralIcon = ({
  monochrome,
  ...props
}: { active?: boolean; monochrome?: boolean; activeColor?: string } & SvgIconProps) => {
  return (
    <StyledSvgIconWrapper viewBox="0 0 60 58" {...props} fill="none">
      <svg width="60" height="58" viewBox="0 0 60 58" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M30.13 25.5C22.11 35.74 21.12 55.5 30.01 55.5C42.01 55.5 39.01 19.5 20.01 19.5C1.00999 19.5 2.00999 55.5 2.00999 55.5"
          stroke="#003939"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={monochrome ? "stroke" : ""}
        />
        <path
          d="M58.01 55.5C58.01 55.5 58.01 19.5 41.01 19.5C39.96 19.5 38.96 19.64 38 19.89C37.31 20.07 36.64 20.32 36 20.62"
          stroke="#32B88E"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="stroke"
        />
        <path
          d="M19.01 13C22.5999 13 25.51 10.0899 25.51 6.5C25.51 2.91015 22.5999 0 19.01 0C15.4202 0 12.51 2.91015 12.51 6.5C12.51 10.0899 15.4202 13 19.01 13Z"
          fill="#003939"
          className={monochrome ? "fill" : ""}
        />
        <path
          d="M41 13C44.5899 13 47.5 10.0899 47.5 6.5C47.5 2.91015 44.5899 0 41 0C37.4101 0 34.5 2.91015 34.5 6.5C34.5 10.0899 37.4101 13 41 13Z"
          fill="#32B88E"
          className="fill"
        />
      </svg>
    </StyledSvgIconWrapper>
  );
};
